import React from 'react'
import { MotionCard, MotionSection } from '../motion/Motion'

export default function WhyInvestSection() {
  return (
    <MotionSection className="w-[96%] mx-auto py-14">
      <div className="max-w-7xl mx-auto">
        {/* Text column */}
        <div className="grid gap-6 lg:grid-cols-2 items-start">
          <div className="space-y-3 text-left">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
              Why Invest in Custom Logo Mats Johannesburg?
              <br />
              <span className="text-pink-500">Maximize Your Branding ROI.</span>
            </h2>
          </div>
          <div className="text-left">
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              Choosing the right partner for your commercial matting is a critical business decision. Johannesburg
              facility managers and marketing teams trust us because we eliminate the common pain points associated
              with international sourcing — from excessive lead times to unpredictable quality:
            </p>
          </div>
        </div>

        <div className="mt-10 lg:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 items-start">
          {/* Column 1 */}
          <MotionCard
            className="bg-pink-50 border border-pink-100 rounded-xl px-5 py-6 shadow-sm text-center flex flex-col items-center"
            delay={0.02}
          >
            <div className="h-10 w-10 rounded-full bg-pink-500 text-white flex items-center justify-center text-sm font-semibold mb-3">
              01
            </div>
            <h3 className="font-semibold text-gray-900 text-sm sm:text-base mb-2">
              Superior, Fade-Resistant Quality (The Durability Advantage)
            </h3>
            <p className="text-[13px] text-gray-600 leading-relaxed text-center">
              <span className="font-semibold">Challenge Solved:</span> Locally printed mats often fail under
              high-traffic and the harsh South African sun.
              <br />
              <span className="font-semibold">Our Solution:</span> We utilize precision-inlaid WaterHog and HD Nylon
              technologies — the global standard for commercial matting. Your logo remains crisp, vibrant, and
              visible for years. Invest in a mat that actually lasts.
            </p>
          </MotionCard>

          {/* Column 2 */}
          <MotionCard
            className="bg-pink-50 border border-pink-100 rounded-xl px-5 py-6 shadow-sm text-center flex flex-col items-center"
            delay={0.07}
          >
            <div className="h-10 w-10 rounded-full bg-pink-500 text-white flex items-center justify-center text-sm font-semibold mb-3">
              02
            </div>
            <h3 className="font-semibold text-gray-900 text-sm sm:text-base mb-2">
              Ultra-Fast South African Lead Times (The Speed Advantage)
            </h3>
            <p className="text-[13px] text-gray-600 leading-relaxed text-center">
              <span className="font-semibold">Challenge Solved:</span> Standard lead times are often 6 to 8
              weeks, causing unacceptable business delays.
              <br />
              <span className="font-semibold">Our Solution:</span> We manage local production and finishing right
              here in Kempton Park. Typically, delivery takes just{' '}
              <span className="font-semibold">2–3 days from final design approval</span>. The fastest turnarounds
              available in Sandton, Randburg, and Pretoria.
            </p>
          </MotionCard>

          {/* Column 3 */}
          <MotionCard
            className="bg-pink-50 border border-pink-100 rounded-xl px-5 py-6 shadow-sm text-center flex flex-col items-center"
            delay={0.12}
          >
            <div className="h-10 w-10 rounded-full bg-pink-500 text-white flex items-center justify-center text-sm font-semibold mb-3">
              03
            </div>
            <h3 className="font-semibold text-gray-900 text-sm sm:text-base mb-2">
              Hassle-Free Local Service (The Convenience Advantage)
            </h3>
            <p className="text-[13px] text-gray-600 leading-relaxed text-center">
              <span className="font-semibold">Challenge Solved:</span> Dealing with international logistics,
              duties, and complex paperwork is exhausting.
              <br />
              <span className="font-semibold">Our Solution:</span> We handle everything. Deal with a local team,
              pay securely in South African Rand (ZAR), and enjoy door-to-door delivery. We also offer optional
              onsite consultation across all major Gauteng business hubs.
            </p>
          </MotionCard>
        </div>
      </div>
    </MotionSection>
  )
}
